/**
 * Catálogo canônico plano (compatibilidade).
 *
 * A organização preferida é por domínio (`tickets.events.ACCEPT`). Estes mapas
 * planos são derivados dos domínios para o código que ainda usa o formato
 * antigo (UI_EVENTS.ACCEPT_TICKET). Não duplique strings aqui.
 */
import { tickets } from "./domains/tickets";
import { contacts } from "./domains/contacts";
import { connections } from "./domains/connections";
import { app } from "./domains/app";

/** @deprecated Use o catálogo por domínio (ex: `tickets.slots.ACTIONS`, `contacts.slots.SIDEBAR`) em vez do mapa plano. */
export const UI_SLOTS = {
  NAVBAR: app.slots.NAVBAR,
  TICKET_ACTIONS: tickets.slots.ACTIONS,
  TICKET_HEADER: tickets.slots.HEADER,
  TICKET_SIDEBAR: tickets.slots.SIDEBAR,
  MESSAGE_INPUT: tickets.slots.MESSAGE_INPUT,
  MESSAGE_ACTIONS: tickets.slots.MESSAGE_ACTIONS,
  DASHBOARD_WIDGETS: "dashboard-widgets",
  CONTACT_ACTIONS: contacts.slots.ACTIONS,
  CONTACT_SIDEBAR: contacts.slots.SIDEBAR,
  NEW_TICKET: tickets.slots.NEW,
  NEW_TICKET_BUTTON: tickets.slots.NEW_BUTTON,
  TICKET_LIST_ITEM_ACTIONS: tickets.slots.LIST_ITEM_ACTIONS,
  TICKET_LIST_ITEM_BADGE: tickets.slots.LIST_ITEM_BADGE,
  CONNECTION_STATUS: connections.slots.STATUS,
  CONNECTION_ACTIONS: connections.slots.ACTIONS,
} as const;

/** @deprecated Use o catálogo por domínio (ex: `tickets.events.ACCEPT`, `contacts.events.EDIT`) em vez do mapa plano. */
export const UI_EVENTS = {
  CREATE_TICKET: tickets.events.CREATE,
  ACCEPT_TICKET: tickets.events.ACCEPT,
  TRANSFER_TICKET: tickets.events.TRANSFER,
  RESOLVE_TICKET: tickets.events.RESOLVE,
  IGNORE_TICKET: tickets.events.IGNORE,
  OPEN_TICKET: tickets.events.OPEN,
  SEND_MESSAGE: tickets.events.SEND_MESSAGE,
  EDIT_CONTACT: contacts.events.EDIT,
  BLOCK_CONTACT: contacts.events.BLOCK,
  SAVE_TICKET_NOTE: contacts.events.SAVE_NOTE,
  CHANGE_KANBAN_STAGE: contacts.events.CHANGE_KANBAN,
} as const;

/** @deprecated Use o catálogo por domínio (ex: `tickets.hooks.NEW_BUTTON_HIDE_NATIVE`) em vez do mapa plano. */
export const UI_HOOKS = {
  NEW_TICKET_BUTTON_HIDE_NATIVE: tickets.hooks.NEW_BUTTON_HIDE_NATIVE,
} as const;
